import React from 'react';
import { Avatar } from 'antd';
import { Link } from 'react-router-dom';
import FeatherIcon from 'feather-icons-react';
import { InfoWraper, UserDropDwon } from './auth-info-style';
// import Message from './message';
// import Notification from './notification';
// import Settings from './settings';
// import Support from './support';
import { Popover } from '../../popup/popup';
// import { Dropdown } from '../../dropdown/dropdown';
import { useAuth } from '../../../contexts/AuthContext';
// import Heading from '../../heading/heading';

const AuthInfo = () => {
    const { user, logout } = useAuth();


    // const [state, setState] = useState( {
    //  flag: 'english',
    // } );
    // const { flag } = state;

    const SignOut = ( e ) => {
        e.preventDefault();
        logout();
    };


    const userContent = (
        <UserDropDwon>
            <div className="user-dropdwon">
                {user && (
                    <figure className="user-dropdwon__info">
                        <img src="https://cdn0.iconfinder.com/data/icons/user-pictures/100/matureman1-512.png" alt="" width="40px"/>
                        <figcaption>
                            <h5>{user.name || user.email || 'User'}</h5>
                            <p>{user.email || 'StrideAhead User'}</p>
                        </figcaption>
                    </figure>
                )}

                <Link to="/admin/myprofile" className="user-dropdwon__bottomAction" >
                    <FeatherIcon icon="user" /> Profile
                </Link>
                <Link className="user-dropdwon__bottomAction" onClick={ SignOut } to="#">
                    <FeatherIcon icon="log-out" /> Sign Out
                </Link>
            </div>
        </UserDropDwon>
    );

    // const onFlagChangeHandle = value => {
    //  setState( {
    //    ...state,
    //    flag: value,
    //  } );
    // };

    // const country = (
    //  <NavAuth>
    //    <Link onClick={ () => onFlagChangeHandle( 'english' ) } to="#">
    //      <img src={ require( '../../../static/img/flag/english.png' ) } alt="" />
    //      <span>English</span>
    //    </Link>
    //    <Link onClick={ () => onFlagChangeHandle( 'germany' ) } to="#">
    //      <img src={ require( '../../../static/img/flag/germany.png' ) } alt="" />
    //      <span>Germany</span>
    //    </Link>
    //    <Link onClick={ () => onFlagChangeHandle( 'spain' ) } to="#">
    //      <img src={ require( '../../../static/img/flag/spain.png' ) } alt="" />
    //      <span>Spain</span>
    //    </Link>
    //    <Link onClick={ () => onFlagChangeHandle( 'turky' ) } to="#">
    //      <img src={ require( '../../../static/img/flag/turky.png' ) } alt="" />
    //      <span>Turky</span>
    //    </Link>
    //  </NavAuth>
    // );

    return (
        <InfoWraper>
            {/*
      <Message />
      <Notification />

      <Settings />
      <Support />

      <div className="nav-author">
        <Dropdown placement="bottomRight" content={ country } trigger="click">
          <Link to="#" className="head-example">
            <img src={ require( `../../../static/img/flag/${ flag }.png` ) } alt="" />
          </Link>
        </Dropdown>
      </div>
      */}

            <div className="nav-author">
                <Popover placement="bottomRight" content={ userContent } action="click">
                    <Link to="#" className="head-example">
                        <Avatar src="https://cdn0.iconfinder.com/data/icons/user-pictures/100/matureman1-512.png" />
                    </Link>
                </Popover>
            </div>
        </InfoWraper>
    );
}

export default AuthInfo;
